
import { useState } from 'react';
import ForumHeader from './components/ForumHeader';
import CategoryList from './components/CategoryList';
import TopicList from './components/TopicList';
import CreateTopicModal from './components/CreateTopicModal';

export default function Forum() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50">
      <ForumHeader onCreateTopic={() => setShowCreateModal(true)} />
      
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Categories Sidebar */}
          <div className="lg:col-span-1">
            <CategoryList 
              selectedCategory={selectedCategory}
              onCategorySelect={setSelectedCategory}
            />
          </div>
          
          {/* Main Content */}
          <div className="lg:col-span-3">
            <TopicList 
              selectedCategory={selectedCategory}
              onCreateTopic={() => setShowCreateModal(true)}
            />
          </div>
        </div>
      </div>

      {showCreateModal && (
        <CreateTopicModal 
          onClose={() => setShowCreateModal(false)}
          selectedCategory={selectedCategory}
        />
      )}
    </div>
  );
}
